import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChildren } from '@angular/core';
import { Classification } from '@app-model/group-classification';
import { CompanyService } from '@app-services/company.service';
import { CheckedOption, CheckedOptionUtils, createTree } from '@app-shared/utils';
import { SessionService } from '@app-store/session/session.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { CheckBoxComponent } from '../checkbox/check-box/check-box.component';

@Component({
    selector: 'app-eligible',
    templateUrl: './eligible.component.html',
    styleUrls: ['./eligible.component.scss'],
    standalone: false
})
export class EligibleComponent implements OnInit {
	@Input()
	classification?: Classification = new Classification();

	@Output()
	event = new EventEmitter<any>();

	@Output()
	remove = new EventEmitter<any>();

	@Output()
	evtSelectedMasterCompany = new EventEmitter<any>();

	@Input()
	modal? = false;

	@Input()
	modalFlag? = false;

	checkBoxUtils: CheckedOptionUtils = new CheckedOptionUtils();

	allCompanies: boolean;
	companyOptions: CheckedOption[];
	rolesOptions: CheckedOption[] = [];
	departamentsOptions: CheckedOption[] = [];
	subdisiariesOptions: CheckedOption[] = [];
	localidadeOptions: CheckedOption[] = [];
	planoSaudeOptions: CheckedOption[] = [];

	@ViewChildren(CheckBoxComponent) checkBoxList: CheckBoxComponent[];

	// companias maiores
	masterCompanies: any[];
	selectedMasterCompany;

	companies = [];

	userIn;

	loading = true;

	flagTestFailure = false;

	usersPipe = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(term => {
				const companyIds = this.companies.reduce((accumulator, currentValue) => {
					if (currentValue.children.length === 0) {
						accumulator.push(currentValue.companyId);
						return accumulator;
					}
					return accumulator.concat(
						currentValue.children.map(c => {
							return c.companyId;
						})
					);
				}, []);

				return this.userAppService.searchUserByName(term, companyIds);
			}),
			map((users: any[]) => {
				users = users.filter(u => {
					let a = this.classification.users?.find(u2 => {
						if (u2.id == u.id) {
							return true;
						}
						return false;
					});
					if (a) {
						return false;
					}
					return true;
				});
				if (users.length <= 0) {
					return [
						{
							name: 'Não foi encontrado ninguém',
							nameEmail: 'Não foi encontrado ninguém',
							placeholder: 'true'
						}
					];
				}

				users.forEach(u => {
					u.nameEmail = `${u.name} / ${u.email}`;
				});

				return users;
			})
		);

	formatter = x => `${x.name} / ${x.email}`;

	constructor(
		private userAppService: SessionService,
		private configurationService: CompanyService,
		private toastrService: ToastrService
	) {}

	// INITS
	ngOnInit() {
		this.loading = true;
		this.configurationService.getCompanies().subscribe(response => {
			this.loading = false;
			this.companies = createTree(response, 'companyId', 'parentCompanyId');

			if (this.classification?.companyMasterId) {
				this.selectedMasterCompany = this.companies.find(c => c.companyId === this.classification.companyMasterId);

				if (this.selectedMasterCompany) {
					this.afterSelectedMasterComanyUpdate(this.selectedMasterCompany.companyId);
				} else {
					this.updateCheckBox();
				}
			} else {
        this.updateCheckBox();
      }
		});
	}
	selectAllOptions() {
		this.checkBoxList.forEach(c => {
			c.forceSelectAll();
		});
	}

	loadPreviousMasterCompany(arr: any[], arrCompanyId: string[]) {
		for (let company of arr) {
			let aux = arrCompanyId.find(id => {
				if (id == company.companyId) {
					return true;
				}
				return false;
			});
			if (aux) {
				return company;
			}
		}
		// if there no option
		return this.masterCompanies.length > 0 ? this.masterCompanies[0] : {};
	}

	afterSelectedMasterComanyUpdate(companyId) {
		this.loading = true;
		this.configurationService.getCompanyById(companyId).subscribe(response => {
			this.companies = createTree(response, 'companyId', 'parentCompanyId');
			if (this.classification) {
				this.selectedMasterCompany = this.companies.find(c => c.companyId === this.classification.companyMasterId);
				this.updateCheckBox();
			}
			this.loading = false;
		});
	}

	afterSelectedMasterComany(canSelect) {
		if (canSelect) {
			this.loading = true;
			this.classification.departamentIds = [];
			this.classification.roleIds = [];
			this.classification.companyIds = [];
			this.classification.companyMasterId = this.selectedMasterCompany.companyId
				? this.selectedMasterCompany.companyId
				: this.selectedMasterCompany.id;
			// update checkbox

			this.configurationService.getCompanyById(this.classification.companyMasterId).subscribe(response => {
				this.companies = createTree(response, 'companyId', 'parentCompanyId');

				if (this.classification) {
					this.selectedMasterCompany = this.companies.find(c => c.companyId === this.classification.companyMasterId);
					this.updateCheckBox(true);
				}
				this.loading = false;
			});
		} else {
			setTimeout(() => {
				this.selectedMasterCompany = null;
				this.toastrService.error('Não pode selecionar a mesma empresa matriz duas vezes');
			}, 10);
		}
	}

	selectMasterCompany(selected = null) {
		this.flagTestFailure = false;
		this.evtSelectedMasterCompany.emit({
			companyId: this.selectedMasterCompany.companyId,
			callback: this.afterSelectedMasterComany,
			comp: this
		});
	}

	selectSubdisiaries(arr: CheckedOption[]) {
		this.flagTestFailure = false;
		this.classification.companyIds = this.checkBoxUtils.extractIdsCheckBoxOption(arr, 'companyId');
	}

	selectCompanies(arr: CheckedOption[]) {
		this.flagTestFailure = false;
		this.classification.companyIds = this.checkBoxUtils.extractIdsCheckBoxOption(arr, 'companyId');
	}

	selectDepartaments(arr: CheckedOption[]) {
		this.flagTestFailure = false;
		this.classification.departamentIds = this.checkBoxUtils.extractIdsCheckBoxOption(arr, 'id');
	}

	selectRoles(arr: CheckedOption[]) {
		this.flagTestFailure = false;
		this.classification.roleIds = this.checkBoxUtils.extractIdsCheckBoxOption(arr, 'id');
	}

	selectPlanosSaude(arr: CheckedOption[]) {
		this.flagTestFailure = false;
		this.classification.healthPlansIds = this.checkBoxUtils.extractIdsCheckBoxOption(arr, 'id');
	}

	selectLocalidade(arr: CheckedOption[]) {
		this.flagTestFailure = false;
		this.classification.localitiesIds = this.checkBoxUtils.extractIdsCheckBoxOption(arr, 'id');
	}

	resetUserIn() {
		setTimeout(() => {
			this.userIn = null;
		}, 1);
	}
	selectOneUser(user) {
		this.flagTestFailure = false;
		if (user.item['placeholder']) {
			this.userIn = null;
			this.resetUserIn();
			return;
		}

		let flag = true;
		// test if user is alreadyt select
		this.classification.users?.forEach(u => {
			if (u.id == user.item.id) {
				flag = false;
			}
		});

		if (flag) {
      if(this.classification.users) {
        this.classification.users?.push(user.item);
        this.classification.userIds = this.checkBoxUtils.extractIdsObject(this.classification.users, 'id');
      } else {
        this.classification.users = [];
        this.classification.userIds = []

        this.classification.users.push(user.item);
        this.classification.userIds = this.checkBoxUtils.extractIdsObject(this.classification.users, 'id');
      }
		}

		this.resetUserIn();
	}

	// Updates
	ngOnChanges(changes: SimpleChanges): void {}

	updateCheckBox(selectAllOptions = false) {
		this.loading = false;
		if (this.selectedMasterCompany) {
			this.updateCheckBoxSubsidiariesCompanies(selectAllOptions);
			this.updateCheckBoxRoles(selectAllOptions);
			this.updateCheckBoxDepartaments(selectAllOptions);
			this.updateCheckBoxLocalidade(selectAllOptions);
			this.updateCheckBoxPlanoSaude(selectAllOptions);
		}
	}

	updatePreviuosSelectedCheckBox(arr: any[], arrCheckBox: CheckedOption[], attr: string) {
		if (arr) {
			arr.forEach(r => {
				let opt = arrCheckBox.find(opt => {
					if (opt.option[attr] == r) {
						return true;
					}
					return false;
				});
				if (opt) {
					opt.checked = true;
				}
			});
		}
	}

	updateCheckBoxRoles(selectAllOptions = false) {
		const roles = this.selectedMasterCompany.companyRoles;
		this.rolesOptions = this.checkBoxUtils.createCheckBoxOptions(roles);
		// load checked boxes
		if (selectAllOptions) {
			this.classification.roleIds = this.checkBoxUtils.extractIdsCheckBoxOption(this.rolesOptions, 'id');
		}
		this.updatePreviuosSelectedCheckBox(this.classification.roleIds, this.rolesOptions, 'id');
	}

	updateCheckBoxLocalidade(selectAllOptions = false) {
		const localidades = this.selectedMasterCompany.companyLocalities;
		this.localidadeOptions = this.checkBoxUtils.createCheckBoxOptions(localidades);
		// load checked boxes
		if (selectAllOptions) {
			this.classification.localitiesIds = this.checkBoxUtils.extractIdsCheckBoxOption(this.localidadeOptions, 'id');
		}

		this.updatePreviuosSelectedCheckBox(this.classification.localitiesIds, this.localidadeOptions, 'id');
	}

	updateCheckBoxPlanoSaude(selectAllOptions = false) {
		const planosSaude = this.selectedMasterCompany.companyHealthPlans;
		this.planoSaudeOptions = this.checkBoxUtils.createCheckBoxOptions(planosSaude);
		// load checked boxes
		if (selectAllOptions) {
			this.classification.healthPlansIds = this.checkBoxUtils.extractIdsCheckBoxOption(this.planoSaudeOptions, 'id');
		}

		this.updatePreviuosSelectedCheckBox(this.classification.healthPlansIds, this.planoSaudeOptions, 'id');
	}

	updateCheckBoxDepartaments(selectAllOptions = false) {
		this.departamentsOptions = this.checkBoxUtils.createCheckBoxOptions(this.selectedMasterCompany.companyDepartaments);
		if (selectAllOptions) {
			this.classification.departamentIds = this.checkBoxUtils.extractIdsCheckBoxOption(this.departamentsOptions, 'id');
		}
		this.updatePreviuosSelectedCheckBox(this.classification.departamentIds, this.departamentsOptions, 'id');
	}

	updateCheckBoxSubsidiariesCompanies(selectAllOptions = false) {
		const children = this.selectedMasterCompany?.children || [];
		children.unshift({
			companyId: this.selectedMasterCompany.companyId,
			companyName: this.selectedMasterCompany.companyName
		});

		this.subdisiariesOptions = this.checkBoxUtils.createCheckBoxOptions(children);
		if (selectAllOptions) {
			this.classification.companyIds = this.checkBoxUtils.extractIdsCheckBoxOption(
				this.subdisiariesOptions,
				'companyId'
			);
		}
		this.updatePreviuosSelectedCheckBox(this.classification.companyIds, this.subdisiariesOptions, 'companyId');
		// insert Matriz
		this.subdisiariesOptions.forEach(op => {
			if (
				op.option.companyId ==
				(this.selectedMasterCompany.companyId ? this.selectedMasterCompany.companyId : this.selectedMasterCompany.id)
			) {
				op.option.companyName = op.option.companyName;
			}
		});
	}

	removeSelf() {
		this.remove.emit(this.classification);
	}

	// UTILS
	removedSelectUser(user) {
		this.classification.users = this.classification.users.filter(u => (u.id != user.id ? true : false));
		this.classification.userIds = this.classification.userIds.filter(id => (id != user.id ? true : false));
	}

	// return the current state
	getStateEligible() {
		// TODO
		return this.classification;
	}

	testComponent() {
		if (
			this.classification.companyIds.length > 0 ||
			this.classification.departamentIds.length > 0 ||
			this.classification.users.length > 0 ||
			this.classification.roleIds.length > 0 ||
			this.classification.localitiesIds.length > 0 ||
			this.classification.healthPlansIds.length > 0
		) {
			return true;
		}
		this.flagTestFailure = true;
		return false;
	}

	handleChangeAvailableForMinors(event) {
		this.classification.availableForMinors = event.target.checked;
	}

	handleChangeAvailableForDependents(event) {
		this.classification.availableForDependents = event.target.checked;
	}
}
